import { Component, OnInit, Input } from '@angular/core';
import { User } from '../../shared/models/user';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'username-checker',
  templateUrl: './username-checker.component.html',
  styleUrls: ['./username-checker.component.css']
})
export class UsernameCheckerComponent implements OnInit {
  public usernameDuplicate:boolean;
  public usernameValid:boolean;
  @Input() user:User;

  constructor(private userService:UserService) { 
    this.usernameDuplicate = false;
    this.usernameValid = false;
  }

  ngOnInit() {
  }

  checkUsername(newUsername:string) {
    this.user.username = newUsername;
    // TODO: stephen need to add some debounce stuff in here...
    this.userService.isDuplicateUsername(this.user.username).then((isDuplicate) => {
      this.usernameDuplicate = false;
      this.usernameValid = false;
      if (isDuplicate) {
        this.usernameDuplicate = true;
      }
      else {
        this.usernameValid = true;
      }
    });
  }                                           


}



// WEBPACK FOOTER //
// ./src/app/shared/username-checker/username-checker.component.ts